import * as Sentry from "@sentry/react";
import posthog from "posthog-js";

const token = import.meta.env.VITE_POSTHOG_PROJECT_TOKEN_RECEPTION;
const host = import.meta.env.VITE_POSTHOG_HOST;
const stage = import.meta.env.VITE_APP_STAGE;
const isProductionLike = stage === "stg" || stage === "prd";

// ローカル・dev では PostHog の初期化自体を行わない（データ収集しない）
if (isProductionLike) {
  if (token && host) {
    try {
      posthog.init(token, {
        api_host: host,
        defaults: "2026-01-30",
      });
    } catch (error) {
      Sentry.captureException(error, { tags: { source: "posthog-init" } });
    }
  } else {
    Sentry.captureMessage(
      "PostHog initialization skipped: VITE_POSTHOG_PROJECT_TOKEN_RECEPTION or VITE_POSTHOG_HOST is not set",
      "warning"
    );
  }
}

export default posthog;
